import React, { Component } from 'react'
import ReactNative, { I18nManager, PixelRatio, Platform } from 'react-native'
import PropTypes from 'prop-types'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import qs from 'qs'
import * as Portal from '@gorhom/portal'

// ducks
import { getStore } from 'ducks'

import { initTracing } from 'utils/tracing'
import { initTimings } from 'utils/timings'
import packageJSON from '../package.json'

// components
import Runner from './components'
import Loading from './components/Loading'

console.log('Runner version, from package.json:', packageJSON.version)

// Dependents will need to initialize tracing.
export { initTracing }

window.React = React
window.ReactNative = ReactNative
window.Portal = Portal

initTimings()

try {
  I18nManager.allowRTL(false)
  I18nManager.forceRTL(false)
} catch (e) {
  console.error('Error on disable RTL mirroring')
}

export default class RunnerWrapper extends Component {
  static defaultProps = {
    libraries: {},
  }

  static childContextTypes = {
    getBaseURL: PropTypes.func,
    getBaseAPIURL: PropTypes.func,
    getAssetURL: PropTypes.func,
    getUploadsBaseURL: PropTypes.func,
    getFileUploadsBaseURL: PropTypes.func,
    getImageUploadsBaseURL: PropTypes.func,
    getNotificationsURL: PropTypes.func,
    getTransitionStyle: PropTypes.func,
    getDatasources: PropTypes.func,
    getLibraryComponent: PropTypes.func,
    getStore: PropTypes.func,
    isPreviewer: PropTypes.bool,
    getOffsetTop: PropTypes.func,
    appVersion: PropTypes.string,
    activeDevice: PropTypes.string,
    disableAnalytics: PropTypes.bool,
    getFlags: PropTypes.func,
    getWebNotificationConfig: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.store = getStore()
    this.persistor = persistStore(this.store)
  }

  getChildContext() {
    const { previewer, appVersion, disableAnalytics, activeDevice } = this.props

    return {
      appVersion,
      disableAnalytics,
      activeDevice,
      getBaseURL: this.getBaseURL,
      getBaseAPIURL: this.getBaseAPIURL,
      getAssetURL: this.getAssetURL,
      getUploadsBaseURL: this.getUploadsBaseURL,
      getFileUploadsBaseURL: this.getFileUploadsBaseURL,
      getImageUploadsBaseURL: this.getImageUploadsBaseURL,
      getNotificationsURL: this.getNotificationsURL,
      getTransitionStyle: this.getTransitionStyle,
      getDatasources: this.getDatasources,
      getLibraryComponent: this.getLibraryComponent,
      getStore: this.getStore,
      isPreviewer: previewer,
      getOffsetTop: this.getOffsetTop,
      getFlags: this.getFlags,
      getWebNotificationConfig: this.getWebNotificationConfig,
    }
  }

  getBaseURL = () => {
    const { baseURL } = this.props

    return baseURL
  }

  getBaseAPIURL = () => {
    const { baseAPIURL } = this.props

    return baseAPIURL
  }

  getUploadsBaseURL = () => {
    const { uploadsBaseURL } = this.props

    return uploadsBaseURL
  }

  getFileUploadsBaseURL = () => {
    const { fileUploadsBaseURL, uploadsBaseURL } = this.props

    return fileUploadsBaseURL || uploadsBaseURL
  }

  getImageUploadsBaseURL = () => {
    const { imageUploadsBaseURL, uploadsBaseURL } = this.props

    return imageUploadsBaseURL || uploadsBaseURL
  }

  getNotificationsURL = () => {
    const { notificationsURL } = this.props

    return notificationsURL
  }

  getStore = () => this.store

  getOffsetTop = () => {
    const { offsetTop } = this.props

    return offsetTop || 0
  }

  getLibraryComponent = (libraryName, componentName) => {
    const { libraries } = this.props

    if (!libraries[libraryName] || !libraries[libraryName][componentName]) {
      return null
    }

    return libraries[libraryName][componentName]
  }

  getAssetURL = (filename, extraParams = {}) => {
    const { getAssetURL, assetsBaseURL } = this.props

    const { preferRemoteAsset, ...imgixParams } = extraParams
    const params = {
      orient: '',
      auto: Platform.OS === 'web' ? 'format,compress' : 'compress',
      dpr: Math.max(PixelRatio.get(), 2),
      ...(typeof imgixParams === 'object' && { ...imgixParams }),
    }

    if (typeof filename === 'object') {
      filename = filename.url || filename.uri
    }

    if (getAssetURL) {
      return getAssetURL(filename, extraParams)
    }

    return `${assetsBaseURL}/${filename}?${qs.stringify(params)}`
  }

  getTransitionStyle = () => {
    const { transitionStyle } = this.props

    return transitionStyle
  }

  getDatasources = () => {
    const { app } = this.props

    return (app && app.datasources) || {}
  }

  getFlags = () => {
    const { flags } = this.props

    return flags || {}
  }

  getWebNotificationConfig = () => {
    const { webNotificationConfig } = this.props

    return webNotificationConfig || {}
  }

  render() {
    const {
      app,
      onRoute,
      layoutGuides,
      initialRoute,
      deviceId,
      skipNotifications,
      offsetTop,
      marginBottom,
      previewType,
    } = this.props

    return (
      <Provider store={this.store}>
        <PersistGate loading={<Loading />} persistor={this.persistor}>
          <Portal.PortalProvider>
            <Runner
              app={app}
              onNavigate={onRoute}
              layoutGuides={layoutGuides}
              initialRoute={initialRoute}
              deviceId={deviceId}
              skipNotifications={skipNotifications}
              offsetTop={offsetTop}
              marginBottom={marginBottom}
              previewType={previewType}
              apiBaseURL={this.getBaseAPIURL()}
            />
          </Portal.PortalProvider>
        </PersistGate>
      </Provider>
    )
  }
}
